<div class="row animated fadeIn fast">

    <div class="col-12">
        <div class="card border rounded animated fadeIn fast">
            <div class="card-body">
                <form class="form p-t-20"
                      [formGroup]="formInfo"
                      (ngSubmit)="enviar()"
                      class="form-horizontal">
                    <div class="form-body">

                        <div class="row">



                            <!-- uic -->
                            <div class="col-md-3 col-12"
                                 [ngClass]="{ 'has-danger': enviado && f['uic'].errors }">
                                <label class="form-control-label">UIC:</label>
                                <div class="input-group border   rounded">
                                    <div class="input-group-addon"> <i class="fa-solid fa-dolly"></i></div>
                                    <input type="text"
                                           formControlName="uic"
                                           class="form-control"
                                           [ngClass]="{ 'form-control-danger': enviado && f['uic'].errors }">
                                </div>
                                <div *ngIf="enviado && f['uic'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['uic'].errors['required']">Obligatorio</div>
                                    <div *ngIf="f['uic'].errors['formatoIncorrecto']">Formato incorrecto</div>

                                    <div *ngIf="formInfo.get('uic')?.errors?.['apiError']">
                                        {{formInfo.get('uic')?.errors?.['apiError'] }}
                                    </div>

                                </div>
                            </div>

                        </div>
                        <hr>


                        <div class="d-flex">
                            <h6 class="card-subtitle ml-4">

                            </h6>
                            <button [disabled]="loading"
                                    type="submit"
                                    class="ml-auto btn waves-effect waves-light btn-rounded btn-success">
                                <i *ngIf="loading"
                                   class="fa fa-spinner fa-spin"></i>
                                Buscar</button>
                        </div>


                    </div>
                </form>


            </div>
        </div>
    </div>



    <div class="col-12"
         *ngIf="uicLabel.uic">
        <div class="card border rounded animated fadeIn fast border-dark rounded mt-1 p-1">
            <div class="card-body">

                <div class="row">

                    <div class="col-12">
                        <div class="card bg-light">
                            <div class="card-body">
                                <div class="card-text">

                                    <span class="h3"><i class="fa-solid fa-dolly"></i> {{uicLabel.uic}}</span>
                                    <span class="text-info ml-3"
                                          style="font-size: 1.2rem"> {{ uicLabel.cliNombre }} </span><br>

                                    <table class="table table-bordered table-sm mt-1">
                                        <tbody>
                                            <tr>
                                                <td><b>Creado hace </b> {{ uicLabel.created_at! | friendlyDdmmyy}}</td>
                                                <td><b>Estado </b>
                                                    <span [innerHTML]=" uicLabel.estado | uicLabelEstado"></span>
                                                    desde el {{ uicLabel.updated_at | date:'dd/MM/yyyy HH:mm'}}

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div class="row">

                                        <div class="col-12 col-md-6">
                                            <table *ngIf="uicTotales"
                                                   class="table table-bordered table-sm mt-1">
                                                <tbody>
                                                    <tr>
                                                        <th *ngIf="campanyaInfo.camp_cod">Campaña</th>
                                                        <td>{{ campanyaInfo.camp_cod }}
                                                            <small>{{campanyaInfo.descripcion}}</small>
                                                            <span *ngIf="campanyaInfo.campanyaTipo === '1 a 1'"
                                                                  class="text-warning"><br><i>Campaña tipo pedido 1 a 1</i></span>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="listUicsPedido && listUicsPedido.length > 0">
                                                        <th>Pedido</th>
                                                        <td>
                                                            {{ listUicsPedido[0].pedido?.pedido_cli }}
                                                            <small>
                                                                <span [innerHTML]=" listUicsPedido[0].pedido?.estado | pedidoEstado"></span>
                                                                el {{ listUicsPedido[0].pedido?.estado_at | date:'dd/MM/yyyy HH:mm'}}
                                                            </small>
                                                        </td>
                                                    </tr>
                                                    <tr *ngIf="listUicsPedido[0]?.pedido">
                                                        <th></th>
                                                        <td>{{ listUicsPedido[0].pedido?.nombre }} <br>
                                                            {{ listUicsPedido[0].pedido?.direccion }} <br>
                                                            {{ listUicsPedido[0].pedido?.poblacion }} - {{ listUicsPedido[0].pedido?.pais_iso }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>



                                        <div class="col-12 col-md-6">
                                            <table *ngIf="listUics.length"
                                                   class=" tabla-uics table table-bordered table-sm mt-1">
                                                <thead>
                                                    <tr>
                                                        <th>UIC's del pedido {{ listUicsPedido[0].pedido?.pedido_cli }} ({{ listUicsPedido.length}} cajas)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let uic of listUics"
                                                        (click)="seleccionarUIC(uic)">
                                                        <td> <i class="fa-solid fa-box-open"></i> {{ uic }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>


                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>


                </div> <!-- row -->
            </div> <!-- card-body -->
        </div>
    </div>

</div>


<!-- listPreparacion -->
<div class="row animated fadeIn fast"
     *ngIf="listPreparacion.length">
    <div class="col-12 d-none d-md-block">

        <div class="card">
            <div class="card-body">
                <h4 class="card-title"> Detalle de la recogida para {{uicLabel.uic}}</h4>

                <h6 class="card-subtitle"
                    data-toggle="tooltip"
                    title="{{uicTotales.usrRecogida.nombre}}">
                    <i class="fa-solid fa-user mr-1"></i> Asignado a {{uicTotales.usrRecogida.username}} el {{listPreparacion[0].created_at | date:'dd/MM/yyyy HH:mm'}}
                </h6>

                <div class="bootstrap-table">

                    <div>
                        <table class="table table-sm table-striped table-bordered table-hover">

                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Sku</th>
                                    <th><i class="fa fa-barcode"></i> Ean</th>
                                    <th>Artículo</th>
                                    <th>Desde la Ubicación</th>
                                    <th>Lote</th>
                                    <th>Cantidad</th>
                                    <th>Recogido</th>
                                    <th>Estado</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let recogida of listPreparacion">
                                    <td>
                                        <img [src]="fotoDir +'/articulos' + imgResized +  recogida.articulo?.foto"
                                             loading="lazy"
                                             class="rounded pointer border"
                                             height="25px"
                                             (click)="abrirPopupImagen(fotoDir + '/articulos' + '/' + recogida.articulo?.foto)">
                                    </td>
                                    <td>{{ recogida.articulo?.sku }}</td>
                                    <td>{{ recogida.articulo?.ean }}</td>
                                    <td>{{ recogida.articulo?.descripcion }}</td>

                                    <td>
                                        <span class="monospace"
                                              title="{{funcLib.CodUbiDecript(recogida.ubicacion!)}}"
                                              [innerHTML]="funcLib.formatUbicacion(recogida.ubicacion!)">
                                        </span>
                                    </td>

                                    <td>{{ recogida.lote }}</td>
                                    <td style="text-align: right; padding-left: 10px">
                                        <div class="pl-25 mr-20 monospace">
                                            {{ recogida.cant_reserva | number: '0.0-0':'es'}}
                                        </div>
                                    </td>

                                    <td style="text-align: right; padding-left: 10px">
                                        <div class="pl-25 pr-2 mr-20 monospace"
                                             [ngClass]="{
                                                    'bg-green': (recogida.cant_reserva == recogida.cant_recogida) && recogida.cant_recogida! > 0,
                                                    'bg-blue': (recogida.cant_recogida! < recogida.cant_reserva!) && recogida.cant_recogida! > 0
                                                 }">
                                            {{ recogida.cant_recogida | number: '0.0-0':'es'}}
                                        </div>
                                    </td>
                                    <td> <span [innerHTML]=" recogida.estado | uicEstado"></span></td>
                                </tr>
                            </tbody>

                            <tfoot>
                                <tr>
                                    <td colspan="6"
                                        class="text-right"><b>Totales</b></td>
                                    <td style="text-align: right; padding-left: 10px">
                                        <div class="pl-25 mr-20 monospace">
                                            {{ totalCantReserva | number:'0.0-0':'es'}}
                                        </div>
                                    </td>
                                    <td style="text-align: right; padding-left: 10px">
                                        <div class="pl-25 pr-2 mr-20 monospace">
                                            {{ totalCantRecogida | number:'0.0-0':'es'}}
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>
                            </tfoot>


                        </table>
                    </div>


                </div>
            </div>

            <div class="clearfix"></div>
        </div>
    </div>
</div>



<!-- listReparto -->
<div class="row animated fadeIn fast"
     *ngIf="listReparto.length">
    <div class="col-12 d-none d-md-block">

        <div class="card">
            <div class="card-body">
                <h4 class="card-title"> Detalle de la preparación para {{uicLabel.uic}}</h4>

                <h6 class="card-subtitle"
                    data-toggle="tooltip"
                    title="{{uicTotales?.usrReparto?.nombre}}">
                    <i class="fa-solid fa-user mr-1"></i> Asignado a {{uicTotales?.usrReparto?.username}} el {{listReparto[0].created_at | date:'dd/MM/yyyy HH:mm'}}
                </h6>

                <div class="bootstrap-table">

                    <div>
                        <table class="table table-sm table-striped table-bordered table-hover">

                            <thead>
                                <tr>
                                    <th>Cajetín</th>
                                    <th></th>
                                    <th>Sku</th>
                                    <th><i class="fa fa-barcode"></i> Ean</th>
                                    <th>Artículo</th>
                                    <th>En el Pedido</th>
                                    <th>Recogido</th>
                                    <th>Preparado</th>
                                    <th>Estado</th>
                                </tr>
                            </thead>

                            <tbody>
                                <ng-container *ngFor="let reparto of listReparto; let i = index">
                                    <!-- Separador visual cuando cambia el cajétín -->
                                    <tr *ngIf="i > 0 && reparto.cajetin !== listReparto[i-1].cajetin"
                                        class="separator-row">
                                        <td colspan="9"
                                            class="separator-cell">
                                            <hr class="cajetin-separator">
                                        </td>
                                    </tr>

                                    <!-- Fila de datos -->
                                    <tr>
                                        <td>{{ reparto.cajetin }}</td>
                                        <td>
                                            <img [src]="fotoDir +'/articulos' + imgResized + reparto.articulo?.foto"
                                                 loading="lazy"
                                                 class="rounded pointer border"
                                                 height="25px"
                                                 (click)="abrirPopupImagen(fotoDir + '/articulos' + '/' + reparto.articulo?.foto)">
                                        </td>
                                        <td>{{ reparto.articulo?.sku }}</td>
                                        <td>{{ reparto.articulo?.ean }}</td>
                                        <td>{{ reparto.articulo?.descripcion }}</td>

                                        <td style="text-align: right; padding-left: 10px">
                                            <div class="pl-25 mr-20 monospace">
                                                {{ reparto.cant_pedido | number: '0.0-0':'es'}}
                                            </div>
                                        </td>
                                        <td style="text-align: right; padding-left: 10px">
                                            <div class="pl-25 mr-20 monospace">
                                                {{ reparto.cant_repartir | number: '0.0-0':'es'}}
                                            </div>
                                        </td>

                                        <td style="text-align: right; padding-left: 10px">
                                            <div class="pl-25 pr-2 mr-20 monospace"
                                                 [ngClass]="{
                                                        'bg-green': (reparto.cant_repartir == reparto.cant_repartida) && reparto.cant_repartida! > 0,
                                                        'bg-blue': (reparto.cant_repartida! < reparto.cant_repartir!) && reparto.cant_repartida! > 0
                                                     }">
                                                {{ reparto.cant_repartida | number: '0.0-0':'es'}}
                                            </div>
                                        </td>
                                        <td> <span [innerHTML]=" reparto.estado | repartoEstado"></span></td>
                                    </tr>
                                </ng-container>
                            </tbody>

                            <tfoot>
                                <tr>
                                    <td colspan="5"
                                        class="text-right"><b>Totales</b></td>
                                    <td style="text-align: right; padding-left: 10px">
                                        <div class="pl-25 mr-20 monospace">
                                            {{ totalCantPedido | number:'0.0-0':'es'}}
                                        </div>
                                    </td>
                                    <td style="text-align: right; padding-left: 10px">
                                        <div class="pl-25 mr-20 monospace">
                                            {{ totalCantRepartir | number:'0.0-0':'es'}}
                                        </div>
                                    </td>
                                    <td style="text-align: right; padding-left: 10px">
                                        <div class="pl-25 pr-2 mr-20 monospace">
                                            {{ totalCantRepartida | number:'0.0-0':'es'}}
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>
                            </tfoot>


                        </table>
                    </div>

                </div>
            </div>

            <div class="clearfix"></div>
        </div>
    </div>
</div>






<!-- listCajas -->
<div class="row animated fadeIn fast"
     *ngIf="listCajas.length">
    <div class="col-12 d-none d-md-block">

        <div class="card">
            <div class="card-body">
                <h4 class="card-title"> Detalle de las cajas en el reparto para {{uicLabel.uic}}</h4>

                <h6 class="card-subtitle"
                    data-toggle="tooltip"
                    title="{{uicTotales?.usrReparto?.nombre}}">
                    <i class="fa-solid fa-user mr-1"></i> Asignado a {{uicTotales?.usrReparto?.username}} el {{listReparto[0].created_at | date:'dd/MM/yyyy HH:mm'}}
                </h6>

                <div class="bootstrap-table">

                    <div>
                        <table class="table table-sm table-striped table-bordered table-hover">

                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Sku</th>
                                    <th><i class="fa fa-barcode mr-1"></i>Ean</th>
                                    <th>Artículo</th>
                                    <th>Por caja</th>
                                    <th>Cajas</th>
                                    <th>Unidades Totales</th>
                                </tr>
                            </thead>

                            <tbody>
                                <ng-container *ngFor="let linea of listCajas; let i = index">
                                    <!-- Separador visual cuando cambia cajas -->
                                    <tr *ngIf="i > 0 && linea.cajas !== listCajas[i-1].cajas"
                                        class="separator-row">
                                        <td colspan="7"
                                            class="separator-cell">
                                            <hr class="cajetin-separator">
                                        </td>
                                    </tr>

                                    <!-- Fila de datos -->
                                    <tr>
                                        <td>
                                            <img [src]="fotoDir +'/articulos' + imgResized + linea.articulo?.foto"
                                                 loading="lazy"
                                                 class="rounded pointer border"
                                                 height="25px"
                                                 (click)="abrirPopupImagen(fotoDir + '/articulos' + '/' + linea.articulo?.foto)">
                                        </td>
                                        <td>{{ linea.articulo?.sku }}</td>
                                        <td>{{ linea.articulo?.ean }}</td>
                                        <td>{{ linea.articulo?.descripcion }}</td>

                                        <td style="text-align: right; padding-left: 10px">
                                            <div class="pl-25 mr-20 monospace">
                                                {{ linea.cant_cajas_unidades | number: '0.0-0':'es'}}
                                            </div>
                                        </td>

                                        <td style="text-align: right; padding-left: 10px">
                                            <div class="pl-25 mr-20 monospace">
                                                {{ linea.cajas | number: '0.0-0':'es'}}
                                            </div>
                                        </td>

                                        <td style="text-align: right; padding-left: 10px">
                                            <div class="pl-25 mr-20 monospace">
                                                {{ linea.cajas * linea.cant_cajas_unidades | number: '0.0-0':'es'}}
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>

                            <tfoot>
                                <tr>
                                    <td colspan="4"
                                        class="text-right"><b>Totales</b></td>
                                    <td></td>
                                    <td style="text-align: right; padding-left: 10px">
                                        <div class="pl-25 mr-20 monospace">
                                            {{ totalCajas | number:'0.0-0':'es'}}
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>
                            </tfoot>

                        </table>
                    </div>

                </div>
            </div>

            <div class="clearfix"></div>
        </div>
    </div>
</div>



<!-- Modal para mostrar la imagen del artículo -->
<div class="modal-overlay"
     *ngIf="imagenSeleccionada"
     (click)="cerrarPopupImagen()">
    <div class="modal-content">
        <img [src]="imagenSeleccionada"
             class="modal-image"
             alt="Imagen seleccionada">
    </div>
</div>